import { render, staticRenderFns } from "./Metadatos.vue?vue&type=template&id=e6485a1c"
import script from "./Metadatos.vue?vue&type=script&lang=js"
export * from "./Metadatos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6485a1c')) {
      api.createRecord('e6485a1c', component.options)
    } else {
      api.reload('e6485a1c', component.options)
    }
    module.hot.accept("./Metadatos.vue?vue&type=template&id=e6485a1c", function () {
      api.rerender('e6485a1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/globals/aspectos/Metadatos.vue"
export default component.exports